"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function ae(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M7.314 8.25H7.992C9.05175 8.3505 10.032 8.86575 10.7573 9.6075C12.264 11.1368 13.092 13.2945 15.0098 14.4323C16.3958 15.255 18.3345 14.5823 19.0155 13.1918C19.362 13.1858 19.7107 13.1858 20.0573 13.1873C19.5802 14.5995 18.1905 15.6143 16.671 15.75H16.1115C15.1763 15.675 14.2665 15.327 13.5592 14.7255C12.5318 13.8833 11.8717 12.7275 11.073 11.6985C10.386 10.7887 9.6855 9.76575 8.5485 9.3525C7.14375 8.84325 5.4285 9.63975 4.91625 10.9927C4.46625 12.1072 4.83225 13.4887 5.83875 14.2028C6.59325 14.7668 7.644 14.9775 8.55 14.649C9.5565 14.298 10.3035 13.5 10.8765 12.654C11.1023 12.9667 11.322 13.284 11.5395 13.6035C10.6485 14.6888 9.4125 15.621 7.9425 15.75H7.34025C5.48775 15.6255 3.8775 14.103 3.75 12.3045V11.7158C3.87 9.921 5.46 8.3805 7.314 8.25ZM16.074 8.25H16.6365C18.5062 8.36775 20.0963 9.921 20.25 11.7195V12.642C18.7072 12.6555 17.163 12.6465 15.6202 12.648C15.6217 12.378 15.6217 12.1102 15.6202 11.8402C16.8397 11.8372 18.0578 11.8455 19.275 11.8372C19.1888 11.3602 19.077 10.872 18.7845 10.4677C18.072 9.41475 16.5653 8.98425 15.3608 9.44025C14.4008 9.78525 13.6777 10.5397 13.1205 11.3452C12.906 11.0475 12.693 10.7452 12.4867 10.4407C13.3665 9.33975 14.5942 8.38725 16.074 8.25Z", fill: color }));
}
exports["default"] = ae;
//# sourceMappingURL=ae.js.map